import { CardContainerVariantType } from '../../../../../../components/cardContainer/types/cardContainer';
import { CardContainerState } from '../../../../../../components/cardContainer/types/state';
import { commonStandardContainerVariantStyles } from '../commonStyles/common';
export const getInformativeStandardStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        // ! Informative variant does not have hover, focus, pressed or disabled states, so we do not define their styles
        [CardContainerVariantType.INFORMATIVE_STANDARD]: {
            isInteractive: false,
            [CardContainerState.DEFAULT]: {
                container: {
                    ...commonStandardContainerVariantStyles(FOUNDATIONS, FONT),
                    background: FOUNDATIONS.color_comp_containers_bg,
                },
            },
        },
    };
};
//# sourceMappingURL=informativeStandard.js.map